import React from 'react'
import { useTranslation } from 'react-i18next';
import PageImg from "../../assets/images/404.png";
export default function Notfound() {
    const { t } = useTranslation();
  return (
    <div className="center-screen">
            <img className="animated fadeIn" src={PageImg} alt={t('empty.notFoundAlt')}/>
    </div>
  )
}